import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuditService, AuditLog } from '../../../services/audit.service';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { TagModule } from 'primeng/tag';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

@Component({
    selector: 'app-audit-logs',
    standalone: true,
    imports: [
        CommonModule,
        TableModule,
        CardModule,
        TagModule,
        InputTextModule,
        IconFieldModule,
        InputIconModule
    ],
    template: `
    <div class="p-4">
      <div class="flex justify-between items-center mb-4">
        <h1 class="text-3xl font-bold m-0">Audit Logs</h1>
      </div>

      <p-card>
        <p-table 
          #dt 
          [value]="logs" 
          [rows]="20" 
          [paginator]="true" 
          [globalFilterFields]="['action', 'entityType', 'details', 'user']"
          responsiveLayout="scroll"
          styleClass="p-datatable-sm p-datatable-striped"
        >
          <ng-template pTemplate="caption">
            <div class="flex justify-end">
              <p-iconfield iconPosition="left">
                <p-inputicon styleClass="pi pi-search"></p-inputicon>
                <input 
                  pInputText 
                  type="text" 
                  (input)="dt.filterGlobal($any($event.target).value, 'contains')" 
                  placeholder="Search logs..." 
                />
              </p-iconfield>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="timestamp">Time <p-sortIcon field="timestamp"></p-sortIcon></th>
              <th pSortableColumn="user">User <p-sortIcon field="user"></p-sortIcon></th>
              <th pSortableColumn="action">Action <p-sortIcon field="action"></p-sortIcon></th>
              <th pSortableColumn="entityType">Type <p-sortIcon field="entityType"></p-sortIcon></th>
              <th>Details</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-log>
            <tr>
              <td>{{ log.timestamp | date:'short' }}</td>
              <td>{{ log.user }}</td>
              <td>
                <p-tag [value]="log.action" [severity]="getSeverity(log.action)"></p-tag>
              </td>
              <td>{{ log.entityType }}</td>
              <td>{{ log.details }}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </div>
  `
})
export class AuditComponent implements OnInit {
    logs: AuditLog[] = [];

    constructor(private auditService: AuditService) { }

    ngOnInit() {
        this.auditService.getAuditLogs().subscribe(data => {
            this.logs = data;
        });
    }

    getSeverity(action: string): 'success' | 'warn' | 'danger' | 'info' | 'secondary' {
        switch (action.toLowerCase()) {
            case 'create': return 'success';
            case 'update': return 'warn';
            case 'delete': return 'danger';
            case 'login': return 'info';
            default: return 'secondary';
        }
    }
}
